import { useRef, useLayoutEffect, useEffect } from "react"
import styled from "@emotion/styled"
import { css } from "@emotion/react"

import { useConsole } from "contexts/Console"

import { fullGrid } from "css/grid"
import getMediaQuery from "css/breakpoints"

import { useRoller } from "./contexts"

const Root = styled.div`
  align-items: center;
  overflow: hidden;
  scroll-snap-align: end;

  // "Narrow images" ¯\_(ツ)_/¯
  ${props =>
    props.layoutAlt &&
    css`
      ${getMediaQuery("m")} {
        box-sizing: border-box;
        /* display: unset !important; */
        width: 50vw !important;

        // Majesty
        &:nth-of-type(2) {
          padding-inline: calc(var(--grid-col-unit) / 2) !important;
        }
      }
    `}

  // Beautyshot
  &:nth-of-type(1) {
    ${fullGrid}
    display: unset;

    > * {
      grid-column: doc;
      height: 100%;

      img {
        height: 100%;
        object-fit: cover;
        width: 100%;
      }
    }
  }

  // Majesty
  &:nth-of-type(2) {
    // Mobile
    ${getMediaQuery("m", { max: true })} {
      ${fullGrid}

      > * {
        grid-column: main;
      }
    }

    // Desktop
    ${getMediaQuery("m")} {
      display: grid;
      grid-template-columns: unset;
      grid-gap: unset;

      padding-inline: var(--outer-margin);
      width: calc(var(--grid-col-unit) * 4);
    }
  }
`

export default function BeautyShotCardItem({ children, index, layoutAlt }) {
  const console = useConsole()
  const rroot = useRef()

  const { currentIndex } = useRoller()

  useLayoutEffect(() => {
    const root = rroot.current

    const observer = new IntersectionObserver(
      ([{ isIntersecting }]) => {
        if (isIntersecting) {
          currentIndex.set(index)
        }
      },
      { threshold: 0.999, rootMargin: "50px 10px 50px 10px" }
    )
    observer.observe(root)

    return () => {
      observer.unobserve(root)
    }
  })

  const slide = () => rroot.current?.scrollIntoView?.({ behavior: "smooth", block: "end", inline: "start" })

  function onIndexChange(i) {
    if (index !== i) return
    slide()
  }
  useEffect(() => currentIndex.onChange(onIndexChange))

  console.verbose("BeautyshotCardItem(%o)", { children })
  return (
    <Root ref={rroot} layoutAlt={layoutAlt}>
      {children}
    </Root>
  )
}
